webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(1097),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(1087),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(1085),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3792d215",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(1091),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(1089),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6307f258",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(1088),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(1093),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(1095),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(1090),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(1084),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(1086),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(1096),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb006a06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(1092),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/addmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "save"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  เพิ่มข้อมูลเห็ด")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/ownmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "th"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  ข้อมูลเห็ดของท่าน")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/allmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "list"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  ข้อมูลเห็ดทั้งหมด")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/sendmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "th"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  ข้อมูลการส่งเห็ด")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/confirmandalert"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "save"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  บันทึกผลยืนยันและแจ้งเตือน")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mushroom !== null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 text-left"
  }, [_vm._v("\n      ชื่อเห็ดไทย: " + _vm._s(_vm.mushroom.mushroom_thai) + " "), _c('br'), _vm._v("\n      ชื่อวิทยาศาสตร์: " + _vm._s(_vm.mushroom.mushroom_science) + " "), _c('br'), _vm._v("\n      ประเภทเห็ด: " + _vm._s(_vm.getMushroomTypeText(_vm.mushroom.mushroom_type)) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 text-left"
  }, [_vm._v("\n      ผลการตรวจวิเคราะห์: " + _vm._s(_vm.mushroom.analysis_result) + " "), _c('br'), _vm._v("\n      สรุปผลการตรวจวิเคราะห์: " + _vm._s(_vm.mushroom.summary_result) + " "), _c('br'), _vm._v("\n      ผู้ตรวจวิเคราะห์: " + _vm._s(_vm.mushroom.analyst) + " "), _c('br'), _vm._v("\n      หมายเหตุ: " + _vm._s(_vm.mushroom.note) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 text-left"
  }, [_vm._v("\n      ข้อมูลพื้นที่พบเห็ด "), _c('br'), _vm._v("\n      ต." + _vm._s(_vm.mushroom.ttname) + " อ." + _vm._s(_vm.mushroom.amname) + " จ." + _vm._s(_vm.mushroom.prv_name_th) + " "), _c('br'), _vm._v("\n      ละติจูด: " + _vm._s(_vm.mushroom.latitude) + "  "), _c('br'), _vm._v("\n      ลองจิจูด: " + _vm._s(_vm.mushroom.longitude) + "\n    ")])]) : _c('div', {
    staticClass: "row text-center"
  }, [_vm._v("\n    ไม่พบข้อมูลผลวิเคราะห์\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveAlert($event)
      }
    }
  }, [(_vm.mushroom !== null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("แจ้งเตือนไปยังพื้นที่ :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_vm._v("จ." + _vm._s(_vm.mushroom.prv_name_th))])]) : _vm._e(), _vm._v(" "), (_vm.mushroom !== null) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("ข้อความแจ้งเตือน :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v("ภาพประกอบ :")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 text-left",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "image",
      "name": "image",
      "accept": "image/*"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 text-right",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          ส่งการแจ้งเตือน\n        ")])])
}]}

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 form-inline"
  }, [_vm._v("\n            จำนวนเห็ดตามชื่อเห็ด :\n            "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.mushRoomByName), function(item) {
    return _c('li', [_c('p', {
      staticClass: "text-primary"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.searchByClickName(item.mushroom_thai)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.mushroom_thai) + " (" + _vm._s(item.name_count) + ")\n                        ")]), _vm._v(" "), _c('router-link', {
      staticClass: "dropdown-item",
      attrs: {
        "to": ("/editmushroom/" + (item.mushroom_data_id))
      }
    }, [_c('span', [_c('icon', {
      staticStyle: {
        "color": "gray",
        "margin-top": "3px",
        "padding-top": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "name": "pencil"
      }
    })], 1)])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-inline"
  }, [_vm._v("\n            จำนวนเห็ดตามประเภท :\n             "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.mushRoomByType), function(item) {
    return _c('li', [_c('p', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(item.mushroom_type) + " (" + _vm._s(item.name_count) + ")")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-inline"
  }, [_vm._v("\n            ค้นหา ประเภทเห็ด :\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_type),
      expression: "mushroom_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mushroom_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("ทั้งหมด")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_search),
      expression: "mushroom_search"
    }],
    ref: "mushroom_name",
    staticClass: "form-control",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "ค้นตามชื่อเห็ด"
    },
    domProps: {
      "value": (_vm.mushroom_search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mushroom_search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_vm._v("\n              \n            "), (_vm.isLoading) ? _c('p', {
    staticClass: "form-inline"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "32"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchName),
      expression: "isSearchName"
    }]
  }, [_vm._v("\n                ค้นหาพบ \""), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.mushroom_search))]), _vm._v("\"\n                ประเภท " + _vm._s(_vm.getMushroomType) + "\n                จำนวน " + _vm._s(_vm.uploadedFiles.length) + " ภาพ\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.url_file_thumbnail,
        "alt": item.mushroom_thai,
        "width": "150px"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("\n                        " + _vm._s(item.mushroom_thai) + "\n                        "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeMushroom(item)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "red",
        "margin-top": "3px",
        "padding-top": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "name": "trash"
      }
    })], 1)])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#84B329",
      "padding-top": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n            ข้อมูลเห็ดของท่าน\n        ")])])
}]}

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#0f673b",
      "padding-top": "20px"
    }
  }, [_vm._v("\n                    เพิ่มข้อมูลเห็ด\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-style-5"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('input', {
    ref: "mushroom_thai",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อเห็ดไทย"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_science",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อวิทยาศาสตร์"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mushroom_type"
    }
  }, [_vm._v("ประเภทเห็ด:")]), _vm._v(" "), _c('select', {
    ref: "mushroom_type",
    attrs: {
      "id": "mushroom_type"
    }
  }, [_c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])])]), _vm._v(" "), _c('fieldset', [_vm._m(1), _vm._v(" "), _c('input', {
    ref: "mushroom_location",
    attrs: {
      "type": "text",
      "placeholder": "สถานที่เก็บ"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_source_data",
    attrs: {
      "type": "text",
      "placeholder": "แหล่งข้อมูล"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_note",
    attrs: {
      "type": "text",
      "placeholder": "อื่นๆ"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_csrf_token",
      "id": "_csrf_token"
    },
    domProps: {
      "value": _vm.getAuthen.token
    }
  }), _vm._v(" "), _c('fieldset', [_vm._m(2), _vm._v(" "), (_vm.isInitial || _vm.isSaving) ? _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                                    คลิก!! ที่นี่เพื่ออัพโหลดภาพ"), _c('br'), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                                    Uploading " + _vm._s(_vm.fileCount) + " files..."), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "32"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSuccess || _vm.countFilesUpload != 0) ? _c('div', [(_vm.countFilesUpload) ? _c('h2', [_vm._v("Uploaded " + _vm._s(_vm.countFilesUpload) + " file(s) successfully.")]) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "name": "remove"
    }
  }), _vm._v("  ลบภาพทั้งหมด")], 1), _vm._v("\n                                     || \n                                     "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.addImage()
      }
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "green"
    },
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" เพิ่มภาพ")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      attrs: {
        "src": item.url,
        "alt": item.originalName
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed) ? _c('div', [_c('h2', [_vm._v("Uploaded failed.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Try again")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.uploadError))])]) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "บันทึก"
    },
    on: {
      "click": _vm.submitButtionClick
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1")]), _vm._v(" ข้อมูลเห็ด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2")]), _vm._v(" สถานที่เก็บหรือแหล่งข้อมูล")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3")]), _vm._v(" ภาพเห็ด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "tomato"
    }
  }, [_vm._v(" ชื่อภาพต้องเป็นภาษาอังกฤษหรือตัวเลขเท่านั้น "), _c('br'), _vm._v("ถ้าเป็นภาษาไทยจะมีปัญหาในการอัพโหลด")])
}]}

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#ff673b",
      "padding-top": "20px"
    }
  }, [_vm._v("\n                    แก้ไขข้อมูลเห็ด\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-style-5"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('input', {
    ref: "mushroom_thai",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อเห็ดไทย"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_science",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อวิทยาศาสตร์"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mushroom_type"
    }
  }, [_vm._v("ประเภทเห็ด:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_type),
      expression: "mushroom_type"
    }],
    ref: "mushroom_type",
    attrs: {
      "id": "mushroom_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mushroom_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])])]), _vm._v(" "), _c('fieldset', [_vm._m(1), _vm._v(" "), _c('input', {
    ref: "mushroom_location",
    attrs: {
      "type": "text",
      "placeholder": "สถานที่เก็บ"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_source_data",
    attrs: {
      "type": "text",
      "placeholder": "แหล่งข้อมูล"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_note",
    attrs: {
      "type": "text",
      "placeholder": "อื่นๆ"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_csrf_token",
      "id": "_csrf_token"
    },
    domProps: {
      "value": _vm.getAuthen.token
    }
  }), _vm._v(" "), _c('fieldset', [_vm._m(2), _vm._v(" "), (_vm.isInitial || _vm.isSaving) ? _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                                    คลิก!! ที่นี่เพื่ออัพโหลดภาพ"), _c('br'), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                                    Uploading " + _vm._s(_vm.fileCount) + " files..."), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "32"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSuccess || _vm.countFilesUpload != 0) ? _c('div', [(_vm.countFilesUpload) ? _c('h2', [_vm._v("Uploaded " + _vm._s(_vm.countFilesUpload) + " file(s) successfully.")]) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "name": "remove"
    }
  }), _vm._v("  ลบภาพทั้งหมด")], 1), _vm._v("\n                                     || \n                                    "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.addImage()
      }
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "green"
    },
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" เพิ่มภาพ")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      attrs: {
        "src": item.url,
        "alt": item.originalName
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed) ? _c('div', [_c('h2', [_vm._v("Uploaded failed.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Try again")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.uploadError))])]) : _vm._e()]), _vm._v(" "), _c('fieldset', [_vm._m(4), _vm._v(" "), _c('textarea', {
    ref: "mushroom_local_name",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อพื้นเมือง"
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "mushroom_poison",
    attrs: {
      "type": "text",
      "placeholder": _vm.label1
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "mushroom_symptom",
    attrs: {
      "type": "text",
      "placeholder": _vm.label2
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "mushroom_first_aid",
    attrs: {
      "type": "text",
      "placeholder": _vm.label3
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "ตกลง"
    },
    on: {
      "click": _vm.submitButtionClick
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1")]), _vm._v(" ข้อมูลเห็ด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2")]), _vm._v(" สถานที่เก็บหรือแหล่งข้อมูล")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3")]), _vm._v(" ภาพเห็ด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "tomato"
    }
  }, [_vm._v(" ชื่อภาพต้องเป็นภาษาอังกฤษหรือตัวเลขเท่านั้น "), _c('br'), _vm._v("ถ้าเป็นภาษาไทยจะมีปัญหาในการอัพโหลด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left mt-2"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("4")]), _vm._v(" ข้อมูลแสดงในแอพ\n                            ")])
}]}

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    attrs: {
      "align": "right"
    }
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "บันทึกผลยืนยัน"
    },
    on: {
      "click": _vm.openModel
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.mushroom_analysis.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("ไม่พบข้อมูล")])]) : _vm._l((_vm.mushroom_analysis), function(mushroom, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("\n             ชื่อเห็ดไทย: " + _vm._s(mushroom.mushroom_thai) + " "), _c('br'), _vm._v("\n             ชื่อวิทยาศาสตร์: " + _vm._s(mushroom.mushroom_science) + " "), _c('br'), _vm._v("\n             ประเภทเห็ด: {{}} "), _c('br')]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("\n             ผลการตรวจวิเคราะห์: " + _vm._s(mushroom.analysis_result) + " "), _c('br'), _vm._v("\n             สรุปผลการตรวจวิเคราะห์: " + _vm._s(mushroom.summary_result) + " "), _c('br'), _vm._v("\n             ผู้ตรวจวิเคราะห์: " + _vm._s(mushroom.analyst) + " "), _c('br'), _vm._v("\n             หมายเหตุ: " + _vm._s(mushroom.note) + " "), _c('br')]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("\n             ข้อมูลพื้นที่พบเห็ด "), _c('br'), _vm._v("\n             ต." + _vm._s(mushroom.ttname) + " อ." + _vm._s(mushroom.amname) + " จ." + _vm._s(mushroom.prv_name_th) + " "), _c('br'), _vm._v("\n             ละติจูด: " + _vm._s(mushroom.latitude) + "  "), _c('br'), _vm._v("\n             ลองจิจูด: " + _vm._s(mushroom.longitude) + "\n           ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteMushroomAnalysis(mushroom.id, mushroom.mushroom_thai)
        }
      }
    }, [_vm._v("\n               ลบ\n             ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      staticStyle: {
        "width": "80px",
        "margin-top": "8px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.gotoAlertToUser(mushroom.id)
        }
      }
    }, [_vm._v("\n               แจ้งเตือน\n             ")])])])
  })], 2)])])]), _vm._v(" "), (_vm.isModelAdd) ? _c('div', [_c('transition', {
    attrs: {
      "name": "model"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isModelAdd = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("บันทึกผลยืนยัน")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "500px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_c('h5', [_vm._v(" ข้อมูลพื้นที่พบเห็ด ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("จังหวัด")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pvcode),
      expression: "pvcode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pvcode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกจังหวัด --")]), _vm._v(" "), _vm._l((_vm.provinces), function(province) {
    return (_vm.provinces.length > 0) ? _c('option', {
      domProps: {
        "value": province.pvcode
      }
    }, [_vm._v("\n                        " + _vm._s(province.prv_name_th) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("อำเภอ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amcode),
      expression: "amcode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amcode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกอำเภอ --")]), _vm._v(" "), _vm._l((_vm.amphurs), function(amphur) {
    return (_vm.amphurs.length > 0) ? _c('option', {
      domProps: {
        "value": amphur.amcode
      }
    }, [_vm._v("\n                        " + _vm._s(amphur.amname) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ตำบล")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ttcode),
      expression: "ttcode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ttcode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- เลือกตำบล --")]), _vm._v(" "), _vm._l((_vm.tumbons), function(tumbon) {
    return (_vm.tumbons.length > 0) ? _c('option', {
      domProps: {
        "value": tumbon.ttcode
      }
    }, [_vm._v("\n                        " + _vm._s(tumbon.ttname) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.latLngCheck
    },
    on: {
      "change": function($event) {
        _vm.latLngCheck = !_vm.latLngCheck
      }
    }
  }), _vm._v(" ไม่สามารถระบุ ละติจูด ลองจิจูด ได้\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ละติจูด")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.latitude),
      expression: "latitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "ละติจูด",
      "disabled": _vm.latLngCheck
    },
    domProps: {
      "value": (_vm.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.latitude = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ลองจิจูด")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.longitude),
      expression: "longitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "ลองจิจูด",
      "disabled": _vm.latLngCheck
    },
    domProps: {
      "value": (_vm.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.longitude = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_c('h5', [_vm._v(" ข้อมูลเห็ด ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ชื่อสามัญ/ชื่อท้องถิ่นของเห็ด ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_thai),
      expression: "mushroom_thai"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อสามัญ/ชื่อท้องถิ่นของเห็ด"
    },
    domProps: {
      "value": (_vm.mushroom_thai)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mushroom_thai = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ชื่อวิทยาศาสตร์")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_science),
      expression: "mushroom_science"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อวิทยาศาสตร์",
      "name": "mushroom_science"
    },
    domProps: {
      "value": (_vm.mushroom_science)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mushroom_science = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v(" ประเภทเห็ด ")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_type),
      expression: "mushroom_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mushroom_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mushroom_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_c('h5', [_vm._v(" ผลการวิเคราะห์ ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ผลการตรวจวิเคราะห์")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analysis_result),
      expression: "analysis_result"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ผลการตรวจวิเคราะห์"
    },
    domProps: {
      "value": (_vm.analysis_result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.analysis_result = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("สรุปผลการตรวจวิเคราะห์")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.summary_result),
      expression: "summary_result"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "summary_result"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.summary_result = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ไม่ระบุ"
    }
  }, [_vm._v("ไม่ระบุ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "พบสารพิษ"
    }
  }, [_vm._v("พบสารพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ไม่พบสารพิษ"
    }
  }, [_vm._v("ไม่พบสารพิษ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("ผู้ตรวจวิเคราะห์")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analyst),
      expression: "analyst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "ผู้ตรวจวิเคราะห์"
    },
    domProps: {
      "value": (_vm.analyst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.analyst = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('label', [_vm._v("หมายเหตุ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "หมายเหตุ"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitAddData
    }
  }, [_vm._v("\n                     บันทึกข้อมูล\n                  ")])])])])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-left"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("ข้อมูลผลการยืนยันเห็ดพิษ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._v("\n       \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("ลำดับ")]), _vm._v(" "), _c('td', [_vm._v("ข้อมูลเห็ด")]), _vm._v(" "), _c('td', [_vm._v("ผลวิเคราะห์")]), _vm._v(" "), _c('td', [_vm._v("ข้อมูลพื้นที่")]), _vm._v(" "), _c('td', [_vm._v("แจ้งเตือน")])])])
}]}

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 h5"
  }, [_vm._v("\n        ผู้ใช้งาน : " + _vm._s(_vm.getAuthen.typename) + " " + _vm._s(_vm.getAuthen.orgcode) + "\n        "), _c('br'), _vm._v(_vm._s(_vm.getAuthen.orgname) + "\n        "), _c('br'), _vm._v(_vm._s(_vm.getAuthen.register_name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group text-center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "id": "btn_logout",
      "name": "btn_logout",
      "type": "button",
      "value": "ออกจากระบบ"
    },
    on: {
      "click": _vm.clickButtonLogout
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h4', [_vm._v(" ยินดีต้อนรับเข้าสู่ระบบ ")])])
}]}

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 form-inline"
  }, [_vm._v("\n            จำนวนเห็ดตามชื่อเห็ด :\n            "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.mushRoomByName), function(item) {
    return _c('li', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.searchByClickName(item.mushroom_thai)
        }
      }
    }, [_c('p', {
      staticClass: "text-primary"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.searchByClickName(item.mushroom_thai)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.mushroom_thai) + " (" + _vm._s(item.name_count) + ")\n                        ")]), _vm._v(" "), _c('router-link', {
      staticClass: "dropdown-item",
      attrs: {
        "to": ("/editmushroom/" + (item.mushroom_data_id))
      }
    }, [_c('span', [_c('icon', {
      staticStyle: {
        "color": "gray",
        "margin-top": "3px",
        "padding-top": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "name": "pencil"
      }
    })], 1)])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-inline"
  }, [_vm._v("\n            จำนวนเห็ดตามประเภท :\n             "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.mushRoomByType), function(item) {
    return _c('li', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.searchByClickType(item.mushroom_type)
        }
      }
    }, [_c('p', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(item.mushroom_type) + " (" + _vm._s(item.name_count) + ")")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-inline"
  }, [_vm._v("\n            ค้นหา ประเภทเห็ด :\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_type),
      expression: "mushroom_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mushroom_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("ทั้งหมด")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mushroom_search),
      expression: "mushroom_search"
    }],
    ref: "mushroom_name",
    staticClass: "form-control",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "placeholder": "ค้นตามชื่อเห็ด"
    },
    domProps: {
      "value": (_vm.mushroom_search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mushroom_search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_vm._v("\n              \n            "), (_vm.isLoading) ? _c('p', {
    staticClass: "form-inline"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "32"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchName),
      expression: "isSearchName"
    }]
  }, [_vm._v("\n                ค้นหาพบ \""), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.mushroom_search))]), _vm._v("\"\n                ประเภท " + _vm._s(_vm.getMushroomType) + "\n                จำนวน " + _vm._s(_vm.uploadedFiles.length) + " ภาพ\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.url_file_thumbnail,
        "alt": item.mushroom_thai,
        "width": "150px"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("\n                        " + _vm._s(item.mushroom_thai) + "\n                        "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeMushroom(item)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "red",
        "margin-top": "3px",
        "padding-top": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "name": "trash"
      }
    })], 1)])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#099ddc",
      "padding-top": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n            ข้อมูลเห็ดทั้งหมด\n        ")])])
}]}

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "logo-section"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "108px"
    },
    attrs: {
      "src": __webpack_require__(281)
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": __webpack_require__(283)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-center"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center",
      "color": "#6C7A80"
    }
  }, [_vm._v("\n                            ฐานข้อมูลเห็ดพิษ\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center",
      "color": "#6C7A80",
      "font-size": "18px"
    }
  }, [_vm._v("\n                            กรมวิทยาศาสตร์การแพทย์ ร่วมกับ มหาวิทยาลัยมหาสารคาม\n                        ")])])])])])])])
}]}

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_c('p', {
    staticStyle: {
      "color": "#6C7A80"
    }
  }, [_vm._v("\n            ฐานข้อมูลเห็ดพิษ (ThaiMushroom.net) กรมวิทยาศาสตร์การแพทย์ ร่วมกับมหาวิทยาลัยมหาสารคาม ภาคีเครือข่ายนักวิชาการสาธารณสุขและภาคประชาชนร่วมจัดทำขึ้นเพื่อเป็นเครื่องมือคัดกรองเห็ดพิษแบบรวดเร็ว เพื่อการศึกษาและเตือนภัยประชาชนประกอบการตัดสินใจ\n          ")])])])
}]}

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('web-header')], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(!_vm.checkLoginState) ? _c('login-form') : _c('login-info'), _vm._v(" "), _c('menu-d-m-s-c', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkLoginState),
      expression: "checkLoginState"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('router-view')], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n      กรมวิทยาศาสตร์การแพทย์  swindowone@gmail.com\n    ")]), _vm._v(" "), _c('br'), _c('br')])
}]}

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "loginform"
    }
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.submitLogin
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_vm._v("\n        username:"), _c('input', {
    ref: "hph_user",
    attrs: {
      "name": "hph_user",
      "type": "text",
      "placeholder": "กรอกชื่อผู้ใช้งาน",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_vm._v("\n        password:"), _c('input', {
    ref: "hph_pass",
    attrs: {
      "name": "hph_pass",
      "type": "password",
      "placeholder": "กรอกรหัสผ่าน",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('input', {
    ref: "btn_login",
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-left": "80px"
    },
    attrs: {
      "name": "btn_login",
      "type": "submit",
      "value": "Login"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "reset",
      "value": "Cancle"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('h3', [_vm._v(" เข้าสู่ระบบ ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "resumator-textarea-medium"
  }, [_vm._v("\n              (ใช้รหัสเดียวกันกับศูนย์แจ้งเตือนภัยฯ)\n         ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('a', {
    staticClass: "bigbutton",
    attrs: {
      "href": "http://www.tumdee.org/alert/hph/",
      "target": "_blank"
    }
  }, [_vm._v("\n            ลงทะเบียน\n        ")]), _vm._v(" \n        "), _c('a', {
    staticClass: "bigbutton",
    attrs: {
      "href": "http://www.tumdee.org/alert/hph/",
      "target": "_blank"
    }
  }, [_vm._v("\n            ลืมรหัสผ่าน\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 form-group text-center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.thaimushroom.net/mushroom.apk.zip",
      "download": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "src": __webpack_require__(282)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        Download Android App"), _c('br'), _vm._v("\n        (เวอร์ชั่นทดลองใช้)\n        ")])])
}]}

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.mushroomSend), function(item, index) {
    return _c('tr', {
      staticClass: "text-left"
    }, [_c('td', [_vm._v("\n                  " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.note) + " "), _c('br'), _vm._v("\n                " + _vm._s(item.created_at) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ans_rmsc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ans_dcms))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": _vm.getUrlApprove(item.upload_code),
        "target": "_blank"
      }
    }, [_vm._v(" ตอบกลับ ")])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ลำดับ")]), _vm._v(" "), _c('th', [_vm._v("ข้อสงสัย")]), _vm._v(" "), _c('th', [_vm._v("ผู้ส่ง")]), _vm._v(" "), _c('th', [_vm._v("ความเห็นผู้เชี่ยวชาญ ศวก.")]), _vm._v(" "), _c('th', [_vm._v("ความเห็นผู้เชี่ยวชาญกรมวิทย์ฯ")]), _vm._v(" "), _c('th', [_vm._v("จัดการ")])])])
}]}

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_InfoApp__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_InfoApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_InfoApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddMushRoom__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddMushRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AddMushRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_OwnMushRoom__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_OwnMushRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_OwnMushRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AllMushRoom__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AllMushRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AllMushRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EditMushRoom__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EditMushRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_EditMushRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SendMushRoom__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SendMushRoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SendMushRoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ConfirmAndAlert__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ConfirmAndAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ConfirmAndAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AlertToUser__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AlertToUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AlertToUser__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'InfoApp',
    component: __WEBPACK_IMPORTED_MODULE_2__components_InfoApp___default.a
  }, {
    path: '/addmushroom',
    component: __WEBPACK_IMPORTED_MODULE_3__components_AddMushRoom___default.a
  }, {
    path: '/ownmushroom',
    component: __WEBPACK_IMPORTED_MODULE_4__components_OwnMushRoom___default.a
  }, {
    path: '/allmushroom',
    component: __WEBPACK_IMPORTED_MODULE_5__components_AllMushRoom___default.a
  }, {
    path: '/editmushroom/:id',
    component: __WEBPACK_IMPORTED_MODULE_6__components_EditMushRoom___default.a
  }, {
    path: '/sendmushroom',
    component: __WEBPACK_IMPORTED_MODULE_7__components_SendMushRoom___default.a
  }, {
    path: '/confirmandalert',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ConfirmAndAlert___default.a
  }, {
    path: '/alerttouser/:analysisid',
    component: __WEBPACK_IMPORTED_MODULE_9__components_AlertToUser___default.a
  }]
}));

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(1094),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__webpack_require__(124);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2___default.a);
// Vue.prototype.$index = index

// this.$index.getMushroomTypeText(somedata)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebHeader_vue__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WebHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginForm_vue__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoginForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LoginForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoginInfo_vue__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoginInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LoginInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MenuDMSC_vue__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MenuDMSC_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_MenuDMSC_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



global.vuex = __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */];
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'





/* harmony default export */ __webpack_exports__["default"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */],
  name: 'app',
  data: function data() {
    return {};
  },

  methods: {},
  components: {
    WebHeader: __WEBPACK_IMPORTED_MODULE_2__components_WebHeader_vue___default.a,
    LoginForm: __WEBPACK_IMPORTED_MODULE_3__components_LoginForm_vue___default.a,
    LoginInfo: __WEBPACK_IMPORTED_MODULE_4__components_LoginInfo_vue___default.a,
    MenuDMSC: __WEBPACK_IMPORTED_MODULE_5__components_MenuDMSC_vue___default.a
  },
  computed: {
    todos: function todos() {
      return __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].state.todos;
    },
    checkLoginState: function checkLoginState() {
      return __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].state.is_login;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var STATUS_INITIAL = 0;
var STATUS_SAVING = 1;
var STATUS_SUCCESS = 2;
var STATUS_FAILED = 3;
var randomstring = __webpack_require__(114);

/* harmony default export */ __webpack_exports__["default"] = ({
  /* ready () {
    if (this.getAuthen.token === null) {
      alert('not login')
      return
    }
  }, */
  created: function created() {
    if (this.getAuthen.token === '') {
      window.location.replace('/');
    }
  },

  data: function data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos[]',
      countFilesUpload: 0,
      uploadCode: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen']), {
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isLogin: function isLogin() {
      return this.getAuthen.token !== '';
    }
  }),
  methods: {
    reset: function reset() {
      var that = this;
      if (this.uploadCode === null) {
        return;
      }
      var formData = new FormData();
      formData.append('upload_code', this.uploadCode);
      formData.append('token', this.getAuthen.token);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.getUrlUploadDelete(), formData).then(function (response) {
        // console.log(response.data.result)
        var result = response.data.result;
        if (result === 'delete') {
          that.currentStatus = STATUS_INITIAL;
          that.uploadedFiles = [];
          that.uploadError = null;
          that.countFilesUpload = 0;
          that.uploadCode = null;
        }
      }).catch(function (error) {
        // console.log(error.response)
        if (error.response) {
          that.currentStatus = STATUS_FAILED;
          that.uploadError = error.response;
        }
      });
    },
    addImage: function addImage() {
      this.currentStatus = STATUS_INITIAL;
    },
    save: function save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      var that = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.getUrlUpload(), formData).then(function (response) {
        // console.log(response.data)
        // console.log('STATUS_SUCCESS=' + STATUS_SUCCESS)
        that.addUploadFile(response.data);
        that.currentStatus = STATUS_SUCCESS;
      }).catch(function (error) {
        if (error.response) {
          that.currentStatus = STATUS_FAILED;
          // console.log(JSON.stringify(error))
          that.uploadError = error.response;
        }
      });
    },
    filesChange: function filesChange(fieldName, fileList) {
      var _this = this;

      // handle file changes
      if (!fileList.length) return;
      // random number for check file upload in same time
      if (this.uploadCode === null) {
        this.uploadCode = this.getRandomString();
      }
      // alert(this.uploadCode)
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        // alert(fieldName+":"+fileList[x]+":"+fileList[x].name);
        var formData = new FormData();
        formData.append(fieldName, fileList[x], fileList[x].name);
        formData.append('hph_id', _this.getAuthen.hph_id);
        formData.append('token', _this.getAuthen.token);
        formData.append('upload_code', _this.uploadCode);
        _this.save(formData);
      });
    },
    getRandomString: function getRandomString() {
      var options = {
        length: 16,
        charset: 'alphanumeric',
        capitalization: 'lowercase'
      };
      return randomstring.generate(options);
    },
    addUploadFile: function addUploadFile(uploadData) {
      this.countFilesUpload++;
      // console.log(uploadData[0].url)
      var imageInfo = {
        url: uploadData[0].url,
        originalName: uploadData[0].originalName
      };
      this.uploadedFiles.push(imageInfo);
    },
    getUrlUpload: function getUrlUpload() {
      return this.getBaseUrl + '/upload.php';
    },
    getUrlUploadDelete: function getUrlUploadDelete() {
      return this.getBaseUrl + '/upload_delete.php';
    },
    getUrlMushroomSave: function getUrlMushroomSave() {
      return this.getBaseUrl + '/mushroom_save.php';
    },
    resetForm: function resetForm() {
      this.$refs.mushroom_thai.value = '';
      this.$refs.mushroom_science.value = '';
      this.$refs.mushroom_type.value = 'unknown';
      this.$refs.mushroom_location.value = '';
      this.$refs.mushroom_source_data.value = '';
      this.$refs.mushroom_note.value = '';
    },
    submitButtionClick: function submitButtionClick() {
      if (this.uploadCode === null) {
        return;
      }

      var mushroomThai = this.$refs.mushroom_thai.value;
      var mushroomScience = this.$refs.mushroom_science.value;
      var mushroomType = this.$refs.mushroom_type.value;
      var mushroomLocation = this.$refs.mushroom_location.value;
      var mushroomSourceData = this.$refs.mushroom_source_data.value;
      var mushroomNote = this.$refs.mushroom_note.value;
      // alert('mushroomType=' + mushroomType)
      if (mushroomThai === '') {
        alert('กรุณาระบุชื่อเห็ดไทย...');
        return;
      }
      if (this.countFilesUpload === 0) {
        alert('เลือกไฟล์อย่างน้อย 1 รูปภาพ...');
        return;
      }
      var that = this;
      var formData = new FormData();
      formData.append('upload_code', this.uploadCode);
      formData.append('token', this.getAuthen.token);
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('mushroom_thai', mushroomThai);
      formData.append('mushroom_science', mushroomScience);
      formData.append('mushroom_type', mushroomType);
      formData.append('mushroom_location', mushroomLocation);
      formData.append('mushroom_source_data', mushroomSourceData);
      formData.append('mushroom_note', mushroomNote);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(that.getUrlMushroomSave(), formData).then(function (response) {
        console.log('===getUrlMushroomSave');
        console.log(response);
        console.log(response.data.result);
        var result = response.data.result;
        if (result === 'success') {
          that.currentStatus = STATUS_INITIAL;
          that.uploadedFiles = [];
          that.uploadError = null;
          that.countFilesUpload = 0;
          that.uploadCode = null;
          if (window.confirm('บันทึกข้อมูลเรียบร้อยแล้ว \nท่าต้องการล้างข้อมูลที่กรอกหรือไม่ ?')) {
            that.resetForm();
          }
        }
      }).catch(function (error) {
        // console.log(error.response)
        if (error.response) {
          that.currentStatus = STATUS_FAILED;
          that.uploadError = error.response;
        }
      });
    }
  },
  mounted: function mounted() {
    this.reset();
    this.addImage();
    this.submitButtionClick();
    this.resetForm();
  },

  props: [],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon___default.a
  }
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__units__ = __webpack_require__(75);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlertToUser',
  data: function data() {
    return {
      analysisid: '',
      mushroom: null,
      message: '',
      pvcode: '',
      prv_id: ''
    };
  },
  mounted: function mounted() {
    this.analysisid = this.$route.params.analysisid;
  },
  created: function created() {
    this.analysisid = this.$route.params.analysisid;
    this.loadMushroomAnalysisById(this.analysisid);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen']), {
    isLogin: function isLogin() {
      return this.getAuthen.token !== '';
    }
  }),
  methods: {
    loadMushroomAnalysisById: function loadMushroomAnalysisById(id) {
      var _this = this;

      // console.log('loadMushroomAnalysisById id=', id)
      var url = this.getBaseUrl + '/mushroom_analysis_by_id.php';
      var hphId = this.getAuthen.hph_id;
      var token = this.getAuthen.token;
      var formData = new FormData();
      formData.append('hph_id', hphId);
      formData.append('token', token);
      formData.append('id', id);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, formData).then(function (res) {
        var data = res.data;
        // console.log(data)
        // this.mushroom_analysis = data
        if (data.length > 0) {
          _this.mushroom = data[0];
          _this.pvcode = data[0].pvcode;
          _this.prv_id = data[0].prv_id;
          console.log(_this.mushroom);
        }
      });
    },
    getMushroomTypeText: function getMushroomTypeText(mushroomType) {
      return __WEBPACK_IMPORTED_MODULE_3__units__["a" /* units */].getMushroomTypeText(mushroomType);
    },
    saveAlert: function saveAlert(e) {
      var _this2 = this;

      try {
        // const file = e.target.files[0]
        if (this.message === '') {
          alert('กรุณากรอกข้อความแจ้งเตือน');
          return;
        }
        var file = e.target.image.files[0];
        var name = e.target.image.files[0].name;
        // console.log(file)
        // console.log(name)
        // this.item.imageUrl = URL.createObjectURL(file)
        // itemData.append("image1", e.target.image.files[0], e.target.image1.files[0].name);
        var hphId = this.getAuthen.hph_id;
        var token = this.getAuthen.token;
        var formData = new FormData();
        formData.append('hph_id', hphId);
        formData.append('mushroom_analysis_id', this.analysisid);
        formData.append('token', token);
        formData.append('message', this.message);
        formData.append('pvcode', this.pvcode); // for alert area
        formData.append('prv_id', this.prv_id); // for user
        formData.append('image', file, name);
        // file.name
        var url = this.getBaseUrl + '/mushroom_alert_save.php';
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, formData).then(function (res) {
          var data = res.data;
          // console.log(data)
          if (data.result === 'success') {
            alert('ส่งการแจ้งเตือนเรียบร้อยแล้ว');
            _this2.$router.push({ path: '/confirmandalert' });
          }
        });
      } catch (e) {
        alert('กรุณาแนบภาพประกอบ');
      }
    }
  }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      uploadedFiles: [],
      mushRoomByName: [],
      mushRoomByType: [],
      mushroom_search: '',
      mushroom_type: 'all'
    };
  },
  created: function created() {
    if (this.getAuthen.token === '') {
      window.location.replace('/');
      return;
    }
    this.fetchData();
  },
  ready: function ready() {
    this.searchByMushroomName();
  },

  methods: {
    getUrlOwnMushRoom: function getUrlOwnMushRoom() {
      return this.getBaseUrl + '/allmushroom.php';
    },
    getUrlOwnMushRoomSearch: function getUrlOwnMushRoomSearch() {
      return this.getBaseUrl + '/allmushroom_by_search.php';
    },
    getUrlRemoveMushRoom: function getUrlRemoveMushRoom() {
      return this.getBaseUrl + '/remove_mushroom.php';
    },
    getUrlMushroomCountByName: function getUrlMushroomCountByName() {
      return this.getBaseUrl + '/allmushroom_by_name.php';
    },
    getUrlMushroomCountByType: function getUrlMushroomCountByType() {
      return this.getBaseUrl + '/allmushroom_by_type.php';
    },
    searchByClickName: function searchByClickName(name) {
      this.mushroom_search = name;
      // console.log(name)
    },
    searchByClickType: function searchByClickType(type) {
      this.mushroom_type = type;
      this.mushroom_search = '';
    },
    fetchData: function fetchData() {
      var that = this;
      var formData = new FormData();
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('token', this.getAuthen.token);
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlOwnMushRoom(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.uploadedFiles = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
      // count by mushroom name
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlMushroomCountByName(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.mushRoomByName = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
      // count by mushroom type
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlMushroomCountByType(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.mushRoomByType = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
    },
    removeMushroom: function removeMushroom(item) {
      if (confirm('ท่านต้องการลบภาพ ใช่หรือไม่ ?')) {
        // alert(item.upload_id)
        console.log(item.filename);
        var that = this;
        var formData = new FormData();
        formData.append('upload_id', item.upload_id);
        formData.append('filename', item.filename);
        formData.append('token', this.getAuthen.token);
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlRemoveMushRoom(), formData).then(function (response) {
          // var result = response.data
          // console.log(result)
          // alert(result)
          // if (result === 'success') {
          that.loading = false;
          that.fetchData();
          // alert('ลบข้อมูลเรียบร้อยแล้ว')
          // }
          // that.uploadedFiles = result
        }).catch(function (error) {
          // if (error.response) {
          // console.log(error.response)
          // }
          alert('ผิดพลาด: ' + error.response);
        });
      }
    },
    searchByMushroomName: function searchByMushroomName() {
      var _this = this;

      var search = this.mushroom_search; // this.$refs.mushroom_name.value
      var mushroomType = this.mushroom_type;
      // alert(search)
      // var that = this
      var formData = new FormData();
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('token', this.getAuthen.token);
      formData.append('search', search);
      formData.append('mushroom_type', mushroomType);
      this.loading = true;
      this.uploadedFiles = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlOwnMushRoomSearch(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        _this.loading = false;
        _this.uploadedFiles = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen']), {
    isLoading: function isLoading() {
      return this.loading;
    },
    isSearchName: function isSearchName() {
      return this.mushroom_search !== '';
    },
    getMushroomType: function getMushroomType() {
      var type = {
        all: 'ทั้งหมด',
        unknown: 'ไม่ทราบ',
        poison: 'เห็ดพิษ',
        edible: 'เห็ดกินได้'
      };
      return type[this.mushroom_type];
    }
  }),
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default.a
  },
  watch: {
    'mushroom_search': function mushroom_search(val, oldVal) {
      // alert(val.length)
      if (val.length >= 3) {
        this.searchByMushroomName();
      }
    },
    'mushroom_type': function mushroom_type(val, oldVal) {
      // alert(val)
      this.searchByMushroomName();
    }
  }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__units__ = __webpack_require__(75);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmAndAlert',
  data: function data() {
    return {
      isModelAdd: false,
      provinces: [],
      amphurs: [],
      tumbons: [],
      pvcode: '',
      amcode: '',
      ttcode: '',
      latLngCheck: false,
      latitude: '',
      longitude: '',
      mushroom_thai: '',
      mushroom_science: '',
      mushroom_type: '',
      analysis_result: '',
      summary_result: '',
      analyst: '',
      note: '',
      mushroom_analysis: []
    };
  },
  created: function created() {
    this.latLngCheck = false;
    this.loadProvince();
    this.loadMushroomAnalysis();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen']), {
    isLogin: function isLogin() {
      return this.getAuthen.token !== '';
    }
  }),
  methods: {
    openModel: function openModel() {
      this.isModelAdd = true;
    },
    getMushroomTypeText: function getMushroomTypeText(mushroomType) {
      return __WEBPACK_IMPORTED_MODULE_3__units__["a" /* units */].getMushroomTypeText(mushroomType);
    },
    loadProvince: function loadProvince() {
      var _this = this;

      var url = this.getBaseUrl + '/province.php';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (res) {
        var data = res.data;
        _this.provinces = data;
      });
    },
    loadAmphur: function loadAmphur(provinceId) {
      var _this2 = this;

      var url = this.getBaseUrl + '/amphur.php?provinceId=' + provinceId;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (res) {
        var data = res.data;
        _this2.amphurs = data;
      });
    },
    loadTumbon: function loadTumbon(amcode) {
      var _this3 = this;

      var url = this.getBaseUrl + '/tumbon.php?amcode=' + amcode;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (res) {
        var data = res.data;
        _this3.tumbons = data;
      });
    },
    loadMushroomAnalysis: function loadMushroomAnalysis() {
      var _this4 = this;

      var url = this.getBaseUrl + '/mushroom_analysis.php';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (res) {
        var data = res.data;
        _this4.mushroom_analysis = data;
      });
    },
    submitAddData: function submitAddData() {
      var _this5 = this;

      // let actionButton = this.actionButton
      // console.log('actionButton=', actionButton)
      // Vue.swal('Hello Vue world!!!')
      // this.$swal('Hello Vue world!!!')
      // alert('actionButton')
      // this.functionAlert('Hello', 'yessss')
      if (this.pvcode === '') {
        alert('กรุณาเลือกจังหวัด');
        return;
      }

      if (this.amcode === '') {
        alert('กรุณาเลือกอำเภอ');
        return;
      }

      if (this.ttcode === '') {
        alert('กรุณาเลือกตำบล');
        return;
      }

      // console.log('this.latLngCheck=', this.latLngCheck, typeof this.latLngCheck)
      // console.log('this.latitude=', this.latitude)
      if (this.latLngCheck === false) {
        if (this.latitude === '0' && this.latitude !== '') {
          alert('กรุณากรอกละติจูด');
          return;
        }
        if (this.longitude === '0' && this.longitude !== '') {
          alert('กรุณากรอกลองจิจูด');
          return;
        }
      }

      if (this.mushroom_thai === '') {
        alert('กรุณากรอกชื่อสามัญ/ชื่อท้องถิ่นของเห็ด');
        return;
      }
      if (this.analysis_result === '') {
        alert('กรุณากรอกผลการตรวจวิเคราะห์');
        return;
      }
      if (this.analyst === '') {
        alert('กรุณากรอกผู้ตรวจวิเคราะห์');
        return;
      }

      var hphId = this.getAuthen.hph_id;
      var token = this.getAuthen.token;
      /* let data = {
        hph_id: hphId,
        token: token,
        pvcode: this.pvcode,
        amcode: this.amcode,
        ttcode: this.ttcode,
        latitude: this.latitude,
        longitude: this.longitude,
        mushroom_thai: this.mushroom_thai,
        mushroom_science: this.mushroom_science,
        mushroom_type: this.mushroom_type,
        analysis_result: this.analysis_result,
        summary_result: this.summary_result,
        analyst: this.analyst,
        note: this.note
      } */

      var formData = new FormData();
      formData.append('hph_id', hphId);
      formData.append('token', token);
      formData.append('pvcode', this.pvcode);
      formData.append('amcode', this.amcode);
      formData.append('ttcode', this.ttcode);
      formData.append('latitude', this.latitude);
      formData.append('longitude', this.longitude);
      formData.append('mushroom_thai', this.mushroom_thai);
      formData.append('mushroom_science', this.mushroom_science);
      formData.append('mushroom_type', this.mushroom_type);
      formData.append('analysis_result', this.analysis_result);
      formData.append('summary_result', this.summary_result);
      formData.append('analyst', this.analyst);
      formData.append('note', this.note);

      var url = this.getBaseUrl + '/mushroom_analysis_save.php';
      // console.log(data)
      // console.log(formData)
      // console.log('url=', url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, formData).then(function (res) {
        // console.log(res.data)
        _this5.loadMushroomAnalysis();
        _this5.isModelAdd = false;
      });
    },
    deleteMushroomAnalysis: function deleteMushroomAnalysis(id, mushroomName) {
      var _this6 = this;

      if (confirm('ต้องการลบผลวิเคราะห์: ' + mushroomName)) {
        var url = this.getBaseUrl + '/mushroom_analysis_delete.php';
        var hphId = this.getAuthen.hph_id;
        var token = this.getAuthen.token;
        var formData = new FormData();
        formData.append('hph_id', hphId);
        formData.append('token', token);
        formData.append('id', id);
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, formData).then(function (res) {
          if (res.data.result === 'success') {
            _this6.loadMushroomAnalysis();
          }
        });
      }
    },
    gotoAlertToUser: function gotoAlertToUser(id) {
      this.$router.push({ path: '/alerttouser/' + id });
    }
  },
  watch: {
    pvcode: function pvcode(value, valueOld) {
      if (value !== '') {
        if (value !== valueOld) {
          this.amcode = '';
        }
        var provinceId = value;
        this.loadAmphur(provinceId);
      } else {
        this.amphurs = [];
        this.amcode = '';
      }
    },
    amcode: function amcode(value, valueOld) {
      if (value !== valueOld) {
        this.ttcode = '';
      }
      this.loadTumbon(value);
    },
    latLngCheck: function latLngCheck(value) {
      if (value) {
        this.latitude = 0.0;
        this.longitude = 0.0;
      }
    }
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var STATUS_INITIAL = 0;
var STATUS_SAVING = 1;
var STATUS_SUCCESS = 2;
var STATUS_FAILED = 3;
var randomstring = __webpack_require__(114);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditMushRoom',
  data: function data() {
    return {
      id: '',
      loading: false,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos[]',
      countFilesUpload: 0,
      uploadCode: null,
      mushroom_type: 'poison',
      label1: '',
      label2: '',
      label3: ''
    };
  },
  mounted: function mounted() {
    // this.id = this.$route.query.id
    this.id = this.$route.params.id;
    if (this.id !== '') {
      this.fetchData();
      this.reset();
      this.addImage();
      this.submitButtionClick();
      this.resetForm();
    }
  },
  methods: {
    getUrlMushroomById: function getUrlMushroomById() {
      return this.getBaseUrl + '/getmushroom_by_id.php';
    },
    fetchData: function fetchData() {
      var that = this;
      // console.log('load mushroom id=' + this.id)
      var formData = new FormData();
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('token', this.getAuthen.token);
      formData.append('mushroom_data_id', this.id);
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.getUrlMushroomById(), formData).then(function (response) {
        var result = response.data[0];
        // console.log(result)
        // alert(result)
        that.loading = false;
        // that.uploadedFiles = result
        that.uploadCode = result.upload_code;
        that.$refs.mushroom_thai.value = result.mushroom_thai;
        that.$refs.mushroom_science.value = result.mushroom_science;
        that.$refs.mushroom_type.value = result.mushroom_type;
        that.$refs.mushroom_location.value = result.mushroom_location;
        that.$refs.mushroom_source_data.value = result.mushroom_source_data;
        that.$refs.mushroom_note.value = result.mushroom_note;
        that.mushroom_type = result.mushroom_type;
        //
        that.$refs.mushroom_local_name.value = result.mushroom_local_name;
        that.$refs.mushroom_poison.value = result.mushroom_poison;
        that.$refs.mushroom_symptom.value = result.mushroom_symptom;
        that.$refs.mushroom_first_aid.value = result.mushroom_first_aid;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
    },
    reset: function reset() {
      var that = this;
      if (this.uploadCode === null) {
        return;
      }
      var formData = new FormData();
      formData.append('upload_code', this.uploadCode);
      formData.append('token', this.getAuthen.token);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.getUrlUploadDelete(), formData).then(function (response) {
        // console.log(response.data.result)
        var result = response.data.result;
        if (result === 'delete') {
          that.currentStatus = STATUS_INITIAL;
          that.uploadedFiles = [];
          that.uploadError = null;
          that.countFilesUpload = 0;
          // that.uploadCode = null
        }
      }).catch(function (error) {
        // console.log(error.response)
        if (error.response) {
          that.currentStatus = STATUS_FAILED;
          that.uploadError = error.response;
        }
      });
    },
    addImage: function addImage() {
      this.currentStatus = STATUS_INITIAL;
    },
    save: function save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.getUrlUpload(), formData).then(function (response) {
        console.log(response.data);
        // console.log('STATUS_SUCCESS=' + STATUS_SUCCESS)
        that.addUploadFile(response.data);
        that.currentStatus = STATUS_SUCCESS;
      }).catch(function (error) {
        if (error.response) {
          that.currentStatus = STATUS_FAILED;
          console.log(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(error));
          that.uploadError = error.response;
        }
      });
    },
    filesChange: function filesChange(fieldName, fileList) {
      var _this = this;

      // handle file changes
      if (!fileList.length) return;
      // random number for check file upload in same time
      /* if (this.uploadCode === null) {
        this.uploadCode = this.getRandomString()
      } */
      // alert(this.uploadCode)
      if (this.uploadCode === null) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        // alert(fieldName+":"+fileList[x]+":"+fileList[x].name);
        var formData = new FormData();
        formData.append(fieldName, fileList[x], fileList[x].name);
        formData.append('hph_id', _this.getAuthen.hph_id);
        formData.append('token', _this.getAuthen.token);
        formData.append('upload_code', _this.uploadCode);
        _this.save(formData);
      });
    },
    getRandomString: function getRandomString() {
      var options = {
        length: 7,
        charset: 'alphanumeric',
        capitalization: 'lowercase'
      };
      return randomstring.generate(options);
    },
    addUploadFile: function addUploadFile(uploadData) {
      this.countFilesUpload++;
      // console.log(uploadData[0].url)
      var imageInfo = {
        url: uploadData[0].url,
        originalName: uploadData[0].originalName
      };
      this.uploadedFiles.push(imageInfo);
    },
    getUrlUpload: function getUrlUpload() {
      return this.getBaseUrl + '/upload.php';
    },
    getUrlUploadDelete: function getUrlUploadDelete() {
      return this.getBaseUrl + '/upload_delete.php';
    },
    getUrlMushroomSave: function getUrlMushroomSave() {
      return this.getBaseUrl + '/mushroom_save.php';
    },
    getUrlMushroomEdit: function getUrlMushroomEdit() {
      return this.getBaseUrl + '/mushroom_edit.php';
    },
    resetForm: function resetForm() {
      this.$refs.mushroom_thai.value = '';
      this.$refs.mushroom_science.value = '';
      this.$refs.mushroom_type.value = 'unknown';
      this.$refs.mushroom_location.value = '';
      this.$refs.mushroom_source_data.value = '';
      this.$refs.mushroom_note.value = '';
    },
    submitButtionClick: function submitButtionClick() {
      if (this.uploadCode === null) {
        return;
      }
      if (this.id === '') {
        return;
      }

      var mushroomThai = this.$refs.mushroom_thai.value;
      var mushroomScience = this.$refs.mushroom_science.value;
      var mushroomType = this.$refs.mushroom_type.value;
      var mushroomLocation = this.$refs.mushroom_location.value;
      var mushroomSourceData = this.$refs.mushroom_source_data.value;
      var mushroomNote = this.$refs.mushroom_note.value;
      // for app
      var mushroomLocalName = this.$refs.mushroom_local_name.value;
      var mushroomPoison = this.$refs.mushroom_poison.value;
      var mushroomSymptom = this.$refs.mushroom_symptom.value;
      var mushroomFirstAid = this.$refs.mushroom_first_aid.value;
      // alert('mushroomType=' + mushroomType)
      if (mushroomThai === '') {
        alert('กรุณาระบุชื่อเห็ดไทย...');
        return;
      }
      /* if (this.countFilesUpload === 0) {
        alert('เลือกไฟล์อย่างน้อย 1 รูปภาพ...')
        return
      } */
      var that = this;
      var formData = new FormData();
      formData.append('upload_code', this.uploadCode);
      formData.append('token', this.getAuthen.token);
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('mushroom_data_id', this.id);
      formData.append('mushroom_thai', mushroomThai);
      formData.append('mushroom_science', mushroomScience);
      formData.append('mushroom_type', mushroomType);
      formData.append('mushroom_location', mushroomLocation);
      formData.append('mushroom_source_data', mushroomSourceData);
      formData.append('mushroom_note', mushroomNote);
      // for app
      formData.append('mushroom_local_name', mushroomLocalName);
      formData.append('mushroom_poison', mushroomPoison);
      formData.append('mushroom_symptom', mushroomSymptom);
      formData.append('mushroom_first_aid', mushroomFirstAid);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.getUrlMushroomEdit(), formData).then(function (response) {
        // console.log(response.data.result)
        var result = response.data.result;
        if (result === 'success') {
          that.currentStatus = STATUS_INITIAL;
          that.uploadedFiles = [];
          that.uploadError = null;
          that.countFilesUpload = 0;
          // that.uploadCode = null
          if (window.confirm('แก้ไขข้อมูลเรียบร้อยแล้ว \nท่าต้องการล้างข้อมูลที่กรอกหรือไม่ ?')) {
            that.resetForm();
          }
        }
      }).catch(function (error) {
        // console.log(error.response)
        if (error.response) {
          that.currentStatus = STATUS_FAILED;
          that.uploadError = error.response;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen']), {
    isLoading: function isLoading() {
      return this.loading;
    },
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isLogin: function isLogin() {
      return this.getAuthen.token !== '';
    }
  }),
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default.a
  },
  watch: {
    'mushroom_type': function mushroom_type(val, oldVal) {
      // alert(val)
      if (val === 'poison') {
        // this.labels = ['สารพิษ', 'อาการ', 'การปฐมพยาบาล']
        this.label1 = 'กลุ่มสารพิษ';
        this.label2 = 'อาการพิษ';
        this.label3 = 'จังหวัดที่พบ';
      } else {
        // this.labels = ['การปรุง', 'ข้อควรระวัง', 'แหล่งที่พบ']
        this.label1 = 'การปรุง';
        this.label2 = 'ข้อควรระวัง';
        this.label3 = 'จังหวัดที่พบ';
      }
    }
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

module.exports = {
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      msg: 'LoginForm'
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['submitLogin'])),
  props: ['actionLogin']
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['clickButtonLogout'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getAuthen']))
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapActions, mapGetters } from 'vuex'



/**
 * https://github.com/Justineo/vue-awesome/tree/master/src/icons
 * for custom icon
 * Icon.register({
  baidu: {
    width: 23.868,
    height: 26,
    d: 'M3.613 13.701c2.827-.608 2.442-3.986 2.357-4.725-.138-1.139-1.477-3.128-3.296-2.971C.386 6.21.052 9.515.052 9.515c-.309 1.528.74 4.793 3.561 4.186zm3.002 5.875c-.083.238-.268.846-.107 1.375.315 1.187 1.346 1.24 1.346 1.24h1.48v-3.619H7.749c-.713.213-1.057.767-1.134 1.004zM8.86 8.035c1.562 0 2.823-1.797 2.823-4.019C11.683 1.796 10.421 0 8.86 0 7.301 0 6.036 1.796 6.036 4.016c0 2.222 1.265 4.019 2.824 4.019zm6.724.265c2.087.271 3.429-1.956 3.695-3.644.272-1.686-1.074-3.644-2.552-3.98-1.48-.339-3.329 2.032-3.497 3.578-.2 1.89.271 3.778 2.354 4.046zm5.114 9.923s-3.229-2.498-5.113-5.198c-2.555-3.981-6.185-2.361-7.399-.337-1.209 2.024-3.093 3.305-3.36 3.644-.271.334-3.9 2.293-3.095 5.871.806 3.576 3.635 3.508 3.635 3.508s2.085.205 4.504-.336c2.42-.537 4.503.134 4.503.134s5.652 1.893 7.199-1.751c1.545-3.645-.874-5.535-.874-5.535zm-9.671 5.423H7.352c-1.587-.316-2.219-1.4-2.299-1.584-.078-.188-.528-1.059-.29-2.539.686-2.219 2.642-2.379 2.642-2.379h1.956V14.74l1.666.025v8.881zm6.844-.025h-4.229c-1.639-.423-1.716-1.587-1.716-1.587v-4.677l1.716-.027v4.203c.104.447.661.529.661.529h1.742v-4.705h1.825v6.264zm5.986-12.486c0-.808-.671-3.239-3.159-3.239-2.492 0-2.825 2.295-2.825 3.917 0 1.548.131 3.71 3.227 3.641 3.096-.068 2.757-3.507 2.757-4.319z'
  }
}) */

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default.a
  },
  props: []
});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      uploadedFiles: [],
      mushRoomByName: [],
      mushRoomByType: [],
      mushroom_search: '',
      mushroom_type: 'all'
    };
  },
  created: function created() {
    if (this.getAuthen.token === '') {
      window.location.replace('/');
      return;
    }
    this.fetchData();
  },
  ready: function ready() {
    this.searchByMushroomName();
  },

  methods: {
    getUrlOwnMushRoom: function getUrlOwnMushRoom() {
      return this.getBaseUrl + '/ownmushroom.php';
    },
    getUrlOwnMushRoomSearch: function getUrlOwnMushRoomSearch() {
      return this.getBaseUrl + '/ownmushroom_by_search.php';
    },
    getUrlRemoveMushRoom: function getUrlRemoveMushRoom() {
      return this.getBaseUrl + '/remove_mushroom.php';
    },
    getUrlMushroomCountByName: function getUrlMushroomCountByName() {
      return this.getBaseUrl + '/ownmushroom_by_name.php';
    },
    getUrlMushroomCountByType: function getUrlMushroomCountByType() {
      return this.getBaseUrl + '/ownmushroom_by_type.php';
    },
    searchByClickName: function searchByClickName(name) {
      this.mushroom_search = name;
      // console.log(name)
    },
    editMushroom: function editMushroom(item) {
      console.log(item);
      // alert(item)
    },
    fetchData: function fetchData() {
      var that = this;
      var formData = new FormData();
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('token', this.getAuthen.token);
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlOwnMushRoom(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.uploadedFiles = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
      // count by mushroom name
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlMushroomCountByName(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.mushRoomByName = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
      // count by mushroom type
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlMushroomCountByType(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.mushRoomByType = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
    },
    removeMushroom: function removeMushroom(item) {
      if (confirm('ท่านต้องการลบภาพ ใช่หรือไม่ ?')) {
        // alert(item.upload_id)
        // console.log(item.filename)
        var that = this;
        var formData = new FormData();
        formData.append('upload_id', item.upload_id);
        formData.append('filename', item.filename);
        formData.append('token', this.getAuthen.token);
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlRemoveMushRoom(), formData).then(function (response) {
          that.loading = false;
          that.fetchData();
        }).catch(function (error) {
          alert('ผิดพลาด: ' + error.response);
        });
      }
    },
    searchByMushroomName: function searchByMushroomName() {
      var search = this.mushroom_search; // this.$refs.mushroom_name.value
      var mushroomType = this.mushroom_type;
      // alert(search)
      var that = this;
      var formData = new FormData();
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('token', this.getAuthen.token);
      formData.append('search', search);
      formData.append('mushroom_type', mushroomType);
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getUrlOwnMushRoomSearch(), formData).then(function (response) {
        var result = response.data;
        // console.log(result)
        // alert(result)
        that.loading = false;
        that.uploadedFiles = result;
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen']), {
    isLoading: function isLoading() {
      return this.loading;
    },
    isSearchName: function isSearchName() {
      return this.mushroom_search !== '';
    },
    getMushroomType: function getMushroomType() {
      var type = {
        all: 'ทั้งหมด',
        unknown: 'ไม่ทราบ',
        poison: 'เห็ดพิษ',
        edible: 'เห็ดกินได้'
      };
      return type[this.mushroom_type];
    }
  }),
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default.a
  },
  watch: {
    'mushroom_search': function mushroom_search(val, oldVal) {
      // alert(val.length)
      if (val.length >= 3) {
        this.searchByMushroomName();
      }
    },
    'mushroom_type': function mushroom_type(val, oldVal) {
      // alert(val)
      this.searchByMushroomName();
    }
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon' */




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sendmushroom',
  data: function data() {
    return {
      loading: false,
      mushroomSend: []
    };
  },
  created: function created() {
    if (this.getAuthen.token === '') {
      window.location.replace('/');
      return;
    }
    this.fetchData();
  },
  ready: function ready() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getBaseUrl', 'getAuthen'])),
  methods: {
    getUrlApprove: function getUrlApprove(code) {
      return this.getBaseUrl + '/approve/rmsc.php?code=' + code;
    },
    getMushroomSend: function getMushroomSend() {
      return this.getBaseUrl + '/mushroom_send.php';
    },
    fetchData: function fetchData() {
      var that = this;
      console.log('hph_id', this.getAuthen.hph_id);
      var formData = new FormData();
      formData.append('hph_id', this.getAuthen.hph_id);
      formData.append('token', this.getAuthen.token);
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.getMushroomSend(), formData).then(function (response) {
        var sendData = response.data;
        console.log(sendData[0]);
        that.loading = false;
        that.mushroomSend = sendData;
        // that.uploadedFiles = result
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
        }
      });
    }
  }
});

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

module.exports = {
  name: 'web-header',
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.0","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.3c6fb6b.png";

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mushrooms.40afb1d.png";

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u_logo.bdb6e23.gif";

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.571dfe0.gif";

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate__);




// import VueCookies from 'vue-cookies'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
// Vue.use(VueCookies)
// base_url: 'https://www.thaimushroom.net'
var state = {
  is_login: false,
  authen: {
    token: '',
    typename: '',
    orgcode: '',
    orgname: '',
    hph_id: '',
    register_name: ''
  },
  base_url: 'https://thaimushroom.net'
  // base_url: 'http://127.0.0.1:8000'
  // base_url: 'http://www.tumdee.org/mushroom'
  // สั่งการทำงานที่ mutations เดี๋ยวลองไปดูที่ console
};var mutations = {
  isLogin: function isLogin(state, login) {
    // state.todos.push({ name: name })
    state.is_login = login;
  },
  setAuthen: function setAuthen(state, data) {
    state.authen = data;
  }

  // ส่วนของ getters เพื่อสามารถนำข้อมูลไปใช้ใน vue conponents อื่นๆได้ครับ
};var getters = {
  is_login: function is_login(state) {
    return state.is_login;
  },
  getAuthen: function getAuthen(state) {
    return state.authen;
  },
  getBaseUrl: function getBaseUrl(state) {
    return state.base_url;
  }
};

var actions = {
  submitLogin: function submitLogin(state, event) {
    event.preventDefault();
    var user = event.target.hph_user.value;
    var pass = event.target.hph_pass.value;
    if (user === '' && pass === '') {
      alert('login:' + user + pass);
      return;
    }
    // check user login
    var data = 'hph_user=' + user + '&hph_pass=' + pass;
    var urlUpload = store.state.base_url + '/user_check_login.php';
    console.log(urlUpload);
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(urlUpload, data).then(function (obj) {
      // alert(obj.data)
      // console.log(obj.data)
      var res = obj.data;
      var response = res.response;
      if (response === 'fail') {
        alert('ข้อมูลผู้ใช้งานระบบไม่ถูกต้อง');
      } else {
        var rows = res.data;
        var typename = rows.typename;
        if (typename === '10-ศูนย์วิชาการ') {
          var orgcode = rows.orgcode;
          var orgname = rows.orgname;
          var hphId = rows.hph_id;
          var province = rows.province;
          var csrfToken = rows.csrf_token;
          var registerName = rows.register_name;
          var authen = {
            orgcode: orgcode,
            orgname: orgname,
            hph_id: hphId,
            province: province,
            token: csrfToken,
            typename: typename,
            register_name: registerName
          };
          store.commit('setAuthen', authen);
          store.commit('isLogin', true);
          // this.$cookies.set('is_login', true)
          // this.$cookies.set('authen', authen)
          window.location.replace('#/addmushroom');
        } else {
          alert('ระบบยังไม่สนับสนุนการทำงานของ :' + typename);
        }
      }
    }).catch(function (error) {
      alert('ผิดพลาด: ' + error);
    });
  },
  clickButtonLogout: function clickButtonLogout(state, control) {
    if (window.confirm('ท่านต้องการออกจากระบบ')) {
      store.commit('isLogin', false);
      store.commit('setAuthen', {
        token: '',
        typename: '',
        orgcode: '',
        orgname: '',
        hph_id: '',
        register_name: ''
      });
      // store.state.route.path  read ok
      // store.state.route.path = '/'
      // window.location.href = '/'
      // this.$router.path({path: '/'})
      window.location.replace('#/');
    }
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  plugins: [__WEBPACK_IMPORTED_MODULE_3_vuex_persistedstate___default()()]
});

global.store = store;
/* harmony default export */ __webpack_exports__["a"] = (store);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return units; });

var units = {
  getMushroomTypeText: function getMushroomTypeText(mushroomType) {
    switch (mushroomType) {
      case 'unknown':
        return 'ไม่ทราบ';
      case 'poison':
        return 'เห็ดพิษ';
      case 'edible':
        return 'เห็ดกินได้';
    }
  }
};

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ })

},[153]);


// WEBPACK FOOTER //
// static/js/app.1a4103fb74f26baecae5.js